import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { connect } from "react-redux";
//  import { Link } from 'react-router-dom'
import {
  fetchMenusIfNeeded,
  selectActivity,
  fetchActivityIfNeeded,
  CLIENT_BASE_URL
} from "../../actions";
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { FooterNote } from "../FooterLinks/FooterNote";
import { SearchView } from "../SearchView/SearchView";

export class ActivityView extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const { match, dispatch } = this.props;
    if (match.params.id) {
      dispatch(selectActivity(match.params.id));
    }

    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
  }

  componentWillReceiveProps(nextProps) {
    const { match, dispatch } = nextProps;
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope));
    }

    const { selectedActivity } = this.props;
    if (selectedActivity !== nextProps.selectedActivity) {
      dispatch(selectActivity(nextProps.match.params.id));
      dispatch(fetchActivityIfNeeded(nextProps.selectedActivity));
    }
  }

  getVodBackground(poster) {
    poster = CLIENT_BASE_URL + poster;
    return {
      backgroundImage: `url('${poster}')`
    };
  }

  toSessionText(detail) {
    return `${detail.city_name} | ${detail.mm} | ${detail.hhmm} | ${
      detail.venue_name
    }`;
  }

  renderSessionBlock(session_details) {
    if (session_details) {
      let sessionItems = [];
      session_details.map((detail, i) => {
        sessionItems.push(this.toSessionText(detail));
      });

      return (
        <div className="sessions">
          <p className="session_lbl">SESSÕES</p>
          sessionItems.map((txt, i) => {<p>txt</p>})
        </div>
      );
    }
  }

  gotoPage = page => {
    this.props.history.push("/pesquisa");
  };

  render() {
    const { menus, dispatch } = this.props;
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];
    const { details } = this.props;

    const movie_detail = details.length ? details[0] : {};

    return (
      <div>
        <Helmet
          title={movie_detail.title}
          meta={[
            { name: "description", content: movie_detail.logline },
            {
              property: "og:image",
              content: CLIENT_BASE_URL + movie_detail.poster
            },
            { property: "og:title", content: movie_detail.title },
            { property: "og:type", content: "article" },
            {
              property: "og:url",
              content:
                CLIENT_BASE_URL + "/actividade/" + this.props.match.params.id
            }
          ]}
        />
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="vod">
          <div
            className="col-md-12 no-pad text-left"
            style={{ position: "relative" }}
          >
            <p className="left-tag">{movie_detail.title}</p>
            <SearchView
              gotoPage={this.gotoPage}
              dispatch={dispatch}
              customStyle={"alignright"}
            />
          </div>
          <div className="row player-wrapper">
            <div
              className="col-md-12 poster"
              style={this.getVodBackground(movie_detail.poster)}
            >
              <div className="overlay">
                <div className="row">
                  <div className="title col-sm-6">
                    <p>{movie_detail.title}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="subtitle col-sm-6">
                    <p>{movie_detail.keywords}</p>
                  </div>
                  <div className="summary col-sm-offset-1 col-sm-5 text-right">
                    <p>{movie_detail.logline}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row description">
            <div className="col-sm-10">
              <div className="share">
                <p>PARTILHA</p>
                <button className="share-fb-btn" />
                <button className="share-twitter-btn" />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-10">
                <div
                  className="desc"
                  dangerouslySetInnerHTML={{ __html: movie_detail.description }}
                />
                {this.renderSessionBlock}
              </div>
            </div>
          </div>
          <FooterLinks bottom_menus={bottom_menus} />
          <FooterNote />
        </div>
      </div>
    );
  }
}

ActivityView.propTypes = {
  dispatch: PropTypes.func.isRequired,

  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  selectedActivity: PropTypes.string.isRequired,
  details: PropTypes.array.isRequired,
  selectedScope: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  const {
    getMenus,
    selectedActivity,
    getActivityDetails,
    selectedScope
  } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingADetail, items: details } = getActivityDetails[
    selectedActivity
  ] || {
    isFetchingADetail: true,
    items: []
  };

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingADetail,
    details,
    selectedActivity,
    selectedScope
  };
}

export default connect(mapStateToProps)(ActivityView);



// WEBPACK FOOTER //
// ./src/views/VodView/ActivityView.js